import { DefaultValidator } from '../'
import { translateValidator } from '../../i18next/i18nextHelpers'
import { withDefaultValidator } from '../formValidators.utils'

const defaultTranslateKey = 'validator.required'

export const required = value => !!value

export const requiredTranslated: DefaultValidator = withDefaultValidator(
  (localeKey?: string) =>
    translateValidator(required, localeKey || defaultTranslateKey),
)
